// Footer.jsx
import React, { useState } from "react";

const Footer = () => {
  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const BG = "#f6f2ec";
  const WHITE = "#ffffff";

  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      alert("Please enter your email.");
      return;
    }
    // هنا يمكنك توصيل النشرة لاحقًا إلى API — الآن نعرض تنبيه مؤقت
    alert(`Thanks! ${email} has been subscribed.`);
    setEmail("");
  };

  const styles = {
    footer: {
      background: BG,
      color: BROWN,
      padding: "48px 20px",
      fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial",
    },
    container: {
      maxWidth: 1200,
      margin: "0 auto",
      display: "flex",
      gap: 32,
      flexWrap: "wrap",
      alignItems: "flex-start",
      justifyContent: "space-between",
    },
    col: {
      flex: "1 1 220px",
      minWidth: 220,
    },
    logoRow: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginBottom: 12,
    },
    logoImg: {
      width: 80,
      height: 80,
      borderRadius: 8,
      padding: 6,
    },
    brand: {
      fontSize: 18,
      fontWeight: 700,
      color: BROWN,
    },
    desc: {
      color: "#5b4b3f",
      lineHeight: 1.6,
      marginTop: 6,
      fontSize: 14,
    },
    linksList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
      display: "flex",
      flexDirection: "column",
      gap: 10,
    },
    link: {
      color: BROWN,
      textDecoration: "none",
      fontSize: 15,
    },
    contactRow: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      color: "#4b3b2f",
      fontSize: 14,
    },
    newsletterForm: {
      display: "flex",
      gap: 8,
      marginTop: 10,
      flexWrap: "wrap",
    },
    input: {
      padding: "10px 14px",
      borderRadius: 8,
      border: `1px solid ${BROWN}33`,
      minWidth: 200,
      flex: "1 1 180px",
      fontSize: 14,
    },
    subscribeBtn: {
      background: OLIVE,
      color: WHITE,
      border: "none",
      padding: "10px 16px",
      borderRadius: 8,
      cursor: "pointer",
      fontWeight: 700,
    },
    socials: {
      display: "flex",
      gap: 12,
      marginTop: 12,
    },
    socialBtn: {
      width: 36,
      height: 36,
      borderRadius: 8,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      background: WHITE,
      color: BROWN,
      boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
      textDecoration: "none",
    },
    bottom: {
      marginTop: 36,
      borderTop: `1px solid ${BROWN}22`,
      paddingTop: 18,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 12,
      color: "#6b5a4d",
      fontSize: 13,
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Column 1 - Brand */}
        <div style={styles.col}>
          <div style={styles.logoRow}>
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1762089600/ybyvejhuq3t6qm2ggqlv.png"
              alt="L'artisan logo"
              style={styles.logoImg}
            />
            <div>
              <div style={styles.brand}>L’ARTISAN</div>
              <div style={{ color: "#6b5a4d", fontSize: 13 }}>Handmade Wooden Décor</div>
            </div>
          </div>

          <p style={styles.desc}>
            Timeless, handcrafted wooden pieces made with care by skilled artisans.
            Sustainable materials — designed to live with you for years.
          </p>

          <div style={styles.socials}>
            {/* Inline SVG icons */}
            <a href="#" aria-label="Instagram" style={styles.socialBtn}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 2H17C20 2 22 4 22 7V17C22 20 20 22 17 22H7C4 22 2 20 2 17V7C2 4 4 2 7 2Z" stroke="#5b3a29" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 11.37C16.1741 12.0667 16.1741 12.7333 16 13.43C15.675 14.9899 14.1199 16 12.5 16C10.8801 16 9.325 14.9899 9 13.43C8.82591 12.7333 8.82591 12.0667 9 11.37C9.325 9.81006 10.8801 8.8 12.5 8.8C14.1199 8.8 15.675 9.81006 16 11.37Z" stroke="#5b3a29" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M17.5 6.51H17.51" stroke="#5b3a29" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>

            <a href="#" aria-label="Facebook" style={styles.socialBtn}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H15C12.7909 2 11 3.79086 11 6V8H9V11H11V22H14V11H16.5L17 8H14V6C14 5.44772 14.4477 5 15 5H18V2Z" fill="#5b3a29"/>
              </svg>
            </a>

            <a href="#" aria-label="Pinterest" style={styles.socialBtn}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C7.03 2 3 6.03 3 11C3 13.87 4.36 16.36 6.67 17.83C6.68 17.04 6.9 15.58 7.12 14.67C7.19 14.37 7.46 13.58 7.46 13.58C7.2 13.04 6.55 11.87 6.55 10.48C6.55 8.24 7.84 6.63 10.04 6.63C11.28 6.63 12.04 7.41 12.04 8.4C12.04 9.48 11.35 10.45 10.39 10.45C9.86 10.45 9.66 10.16 9.66 9.78C9.66 9.11 10.12 8.63 10.98 8.63C12.02 8.63 12.83 9.6 12.83 11.03C12.83 12.58 11.95 14.09 10.49 14.09C8.79 14.09 8.09 12.64 8.09 11.41C8.09 9.43 9.62 7.61 12.93 7.61C15.68 7.61 17.62 9.23 17.62 12.04C17.62 14.81 16.34 16.92 14.71 16.92C13.72 16.92 13.18 16.28 13.18 15.61C13.18 14.92 13.64 14.58 14.07 14.58C14.46 14.58 14.72 14.9 14.72 15.29C14.72 15.94 14.31 16.8 13.11 16.8C10.81 16.8 9 14.71 9 11.97C9 7.89 11.99 4 17 4C20.11 4 21.8 6.26 21.8 9.1C21.8 13.28 19.09 16.59 15.5 16.59" stroke="#5b3a29" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Column 2 - Quick Links */}
        <div style={styles.col}>
          <h4 style={{ marginBottom: 12, color: BROWN }}>Quick Links</h4>
          <ul style={styles.linksList}>
            <li><a style={styles.link} href="#home">Home</a></li>
            <li><a style={styles.link} href="#shop">Shop</a></li>
            <li><a style={styles.link} href="#about">About</a></li>
            <li><a style={styles.link} href="#contact">Contact</a></li>
            <li><a style={styles.link} href="#latest">Latest</a></li>
          </ul>
        </div>

        {/* Column 3 - Contact */}
        <div style={styles.col}>
          <h4 style={{ marginBottom: 12, color: BROWN }}>Contact</h4>
          <div style={styles.contactRow}>
            <div>📞 +20 100 123 4567</div>
            <div>✉️ info@lartisan.com</div>
            <div style={{ marginTop: 8 }}>
              <a href="https://g.page" style={{ ...styles.link, fontSize: 13 }}>View on map</a>
            </div>
          </div>
        </div>

        {/* Column 4 - Newsletter */}
        <div style={styles.col}>
          <h4 style={{ marginBottom: 12, color: BROWN }}>Stay Updated</h4>
          <p style={{ color: "#6b5a4d", marginBottom: 12 }}>
            Join our newsletter for new arrivals & exclusive offers.
          </p>

          <form style={styles.newsletterForm} onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
            <button type="submit" style={styles.subscribeBtn}>Subscribe</button>
          </form>
        </div>
      </div>

      <div style={styles.bottom}>
        <div>© {new Date().getFullYear()} L’ARTISAN. All rights reserved.</div>
        <div>Designed with ♥ by Horizonya</div>
      </div>
    </footer>
  );
};

export default Footer;
